const breakPointPC = 1279;
const breakPointSP = 767;
let resizeFlag     = false;
let windowWidth    = window.innerWidth;
let windowHeight   = window.innerHeight;
let windowWidthJ   = $(window).width();





// ------------------------------------------------------------------------
// visibleButton
// ----- BOTH
// ------------------------------------------------------------------------
const visibleButton = () => {
  let targetButton = document.querySelector('.sw-Top');
  let targetHeight = 100;
  window.addEventListener('scroll', () => {
    let scrollHeight = window.pageYOffset;
    if (scrollHeight > targetHeight) {
      targetButton.classList.remove('is-Hidden');
    } else {
      targetButton.classList.add('is-Hidden');
    }
  });
}



// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^=#]").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
};






export {
  visibleButton,
  anchorLink
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js